export enum Category {
  Treaty = 'treaty',
  Facultative = 'facultative',
  Shared = 'shared',
  GcAnalyticsAndAdvisory = 'analyticsAndAdvisory',
  ClientSupportServices = 'clientSupportServices',
  DataAndDocuments = 'dataAndDocuments',
  PortalsAndApplications = 'portalsAndApplications',
  GenAI = 'genAi',
  RealTimeInsights = 'realTimeInsights',
}

export interface SectionProps {
  backgroundColor?: string;
  separatorColor: string;
  title: string;
  description: string;
  categories: CategoryProps[];
}

export interface CategoryProps {
  id: Category;
  picture: string;
  title: string;
  description?: string;
}
